<template>
    <div>
        <modal
            name="modalSendVoucherContribution"
            id="modalSendVoucherContribution"
            :width="'45%'"
            :height="'auto'"
            :click-to-close="false"
        >
            <form @submit.prevent="sendVoucher">
                <button
                    type="button"
                    class="btn btn-danger btn-sm btn-closed"
                    @click="closeModal"
                >
                    <i class="fa-solid fa-xmark"></i>
                </button>

                <div class="modal-header">
                    <h5 class="modal-title">Enviar recibo</h5>
                </div>

                <div class="modal-body">
                    <div class="form-group mb-3">
                        <label>Correos destino *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="form.emails"
                            placeholder="correo1@dominio.com, correo2@dominio.com"
                        >
                        <small class="text-muted">
                            Separa varios correos con coma.
                        </small>
                        <span class="text-danger" v-if="errors.emails">{{ errors.emails[0] }}</span>
                    </div>

                    <div class="form-group mb-3">
                        <label>Copias (CC)</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="form.cc"
                            placeholder="copia1@dominio.com, copia2@dominio.com"
                        >
                        <small class="text-muted">
                            Opcional. Separa varios correos con coma.
                        </small>
                        <span class="text-danger" v-if="errors.cc">{{ errors.cc[0] }}</span>
                    </div>

                    <div class="form-group mb-3">
                        <label>Comentario</label>
                        <textarea
                            class="form-control"
                            rows="4"
                            v-model="form.comment"
                            placeholder="Escribe un comentario para el correo"
                        ></textarea>
                        <span class="text-danger" v-if="errors.comment">{{ errors.comment[0] }}</span>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="closeModal"
                        :disabled="loading"
                    >
                        Cancelar
                    </button>

                    <button
                        type="submit"
                        class="btn btn-primary"
                        :disabled="loading"
                    >
                        <span v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i> Enviando...
                        </span>
                        <span v-else>
                            <i class="fa-solid fa-paper-plane"></i> Enviar
                        </span>
                    </button>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import request from '@/services/request'

export default {   
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                program_id: '',
                emails: '',
                cc: '',
                comment: ''
            }
        }
    },
    methods: {
        openModal(id) {
            this.resetForm()
            this.form.program_id = id
            this.$modal.show('modalSendVoucherContribution')
        },

        closeModal() {
            this.$modal.hide('modalSendVoucherContribution')
        },

        resetForm() {
            this.errors = {}
            this.form = {
                program_id: '',
                emails: '',
                cc: '',
                comment: ''
            }
        },

        async sendVoucher() {
            this.loading = true
            this.errors = {}

            try {
                let _endpoint = `/program-group-contributions/send-voucher`;

                let response = await request.post(_endpoint, this.form).then(function (response) {
                    return response;
                });

                this.successNotification(response.data.message);
                this.closeModal()
                this.resetForm()
                Event.$emit("event-reload-program-relations-current");
            } catch (error) {
                this.errors = await this.errorNotification(error);
            } finally {
                this.loading = false
            }
        },
        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        }),
    },
     created() {
        Event.$on("event-send-voucher-contribution", (contributionId, email) => {
            this.form.program_id = contributionId
            this.form.emails = email
            this.$modal.show('modalSendVoucherContribution')
        });
    }
}
</script>